module.exports = __webpack_public_path__ + "assets/orange-lg-logo-66d011.svg";